/* ufp-lp.js: Unique Fire Pits landers, shared script (Scaled Marketing, 29 Sep 2026).
   Vanilla, deferred, idempotent: every section prints this tag; it runs once and binds each element once
   (data-ufp-b-<module> flags). Re-binds inside a section on shopify:section:load (theme editor). No jQuery,
   Flickity or lazysizes. Every storage and clipboard call is wrapped in try/catch; the page works without JS. */
(function () {
  'use strict';
  if (window.ufpLp && window.ufpLp.v) return;
  var U = window.ufpLp = window.ufpLp || {};
  U.v = 1;
  window.UFPLP = U;
  U.last = {};

  var doc = document;
  var KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid'];
  var PATHS = /^\/(products|collections|pages|cart|discount)(\/|$|\?)/;
  var reduce = false;
  try { reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
  var fine = false;
  try { fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches; } catch (e) {}

  function $$(root, sel) { return Array.prototype.slice.call((root || doc).querySelectorAll(sel)); }
  function once(el, name) { var k = 'data-ufp-b-' + name; if (el.hasAttribute(k)) return false; el.setAttribute(k, ''); return true; }
  function ss(k, v) { try { if (v === undefined) return window.sessionStorage.getItem(k); window.sessionStorage.setItem(k, v); } catch (e) { return null; } return null; }
  function lander(el) { var r = (el && el.closest && el.closest('[data-ufp-lander]')) || doc.querySelector('[data-ufp-lander]:not([data-ufp-lander=""])'); var k = r && r.getAttribute('data-ufp-lander'); if (!k) { var h = doc.querySelector('[data-ufp-hero][data-ufp-lander]'); k = h && h.getAttribute('data-ufp-lander'); } return k || location.pathname.split('/').pop(); }
  function push(obj) { try { if (window.dataLayer && window.dataLayer.push) window.dataLayer.push(obj); } catch (e) {} }
  function emit(name, detail) { U.last[name] = detail; try { doc.dispatchEvent(new CustomEvent(name, { detail: detail })); } catch (e) {} }
  /* The live Starlite header (.shopify-section-group-header-group.header.sticky, 67 px on phones, 108 px on desktop)
     is position: sticky and slides back in on every scroll up, so in-page jumps leave room for it. A target can ask
     for more room with the CSS custom property --ufp-scroll-extra (e.g. the fire-pits size rail). */
  function headerEl() { return doc.querySelector('.shopify-section-group-header-group.sticky, .main-header.sticky-header'); }
  function headerOffset() { var h = headerEl(); if (!h) return 0; var b = h.getBoundingClientRect().bottom; return b > 0 ? b : 0; }
  function headerSpace() {
    var h = headerEl();
    if (!h) return 0;
    var cs = window.getComputedStyle(h);
    if (cs.display === 'none' || cs.visibility === 'hidden' || !/sticky|fixed/.test(cs.position)) return 0;
    return h.offsetHeight || 0;
  }
  function scrollToEl(el) {
    if (!el) return;
    var extra = 0;
    try { extra = parseFloat(window.getComputedStyle(el).getPropertyValue('--ufp-scroll-extra')) || 0; } catch (e) {}
    var y = el.getBoundingClientRect().top + (window.pageYOffset || doc.documentElement.scrollTop || 0) - headerSpace() - extra - 8;
    y = Math.max(0, Math.round(y));
    try { window.scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' }); } catch (e) { window.scrollTo(0, y); }
  }
  function parseJSON(s) { try { return JSON.parse(s); } catch (e) { return null; } }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  /* plain text -> escaped HTML with every 0410 264 126 as a tel:0410264126 link (GTM phone_click), like snippets/ufp-lp-text */
  function telHtml(t, cta) { return esc(t).split('0410 264 126').join('<a class="ufp-lp-tel" href="tel:0410264126" data-ufp-cta="' + esc(cta || 'phone') + '">0410 264 126</a>'); }
  U.emit = emit;
  U.headerOffset = headerOffset;
  U.headerSpace = headerSpace;
  U.scrollToEl = scrollToEl;

  /* ------------------------------------------------------------ UTM / fbclid pass-through */
  var params = (function () {
    var o = {}, any = false;
    try {
      var q = new URLSearchParams(location.search);
      KEYS.forEach(function (k) { var v = q.get(k); if (v) { o[k] = v; any = true; } });
    } catch (e) {}
    if (any) ss('ufp_utm', JSON.stringify(o));
    else o = parseJSON(ss('ufp_utm') || '{}') || {};
    return o;
  })();
  U.params = params;
  function withParams(href) {
    if (!href || /^(#|tel:|mailto:|sms:|javascript:)/i.test(href)) return href;
    var keys = Object.keys(params);
    if (!keys.length) return href;
    try {
      var u = new URL(href, location.href);
      if (u.origin !== location.origin || !PATHS.test(u.pathname)) return href;
      if (u.pathname === location.pathname && u.hash) return href;
      var target = u;
      if (/^\/discount\//.test(u.pathname) && u.searchParams.get('redirect')) {
        var r = new URL(u.searchParams.get('redirect'), location.origin);
        keys.forEach(function (k) { if (!r.searchParams.has(k)) r.searchParams.set(k, params[k]); });
        u.searchParams.set('redirect', r.pathname + r.search);
        return u.pathname + u.search + u.hash;
      }
      keys.forEach(function (k) { if (!target.searchParams.has(k)) target.searchParams.set(k, params[k]); });
      return u.pathname + u.search + u.hash;
    } catch (e) { return href; }
  }
  U.withParams = withParams;
  function passLinks(root) {
    $$(root, '.ufp-lp a[href]').forEach(function (a) {
      if (a.hasAttribute('data-ufp-nopass')) return;
      var h = a.getAttribute('href'), n = withParams(h);
      if (n !== h) a.setAttribute('href', n);
    });
  }

  /* ------------------------------------------------------------ analytics: data-ufp-cta clicks (inert until GTM triggers exist) */
  function onClick(e) {
    var a = e.target.closest ? e.target.closest('a[href]') : null;
    if (a && a.closest('.ufp-lp') && !a.hasAttribute('data-ufp-nopass')) {
      var h = a.getAttribute('href'), n = withParams(h);
      if (n !== h) a.setAttribute('href', n);
      if (/^\/(products|cart)/.test(n)) tagCart();
    }
    var c = e.target.closest ? e.target.closest('[data-ufp-cta]') : null;
    if (c && c.closest('.ufp-lp')) {
      push({ event: 'ufp_cta_click', ufp_cta: c.getAttribute('data-ufp-cta'), ufp_lander: lander(c), ufp_product: c.getAttribute('data-ufp-product') || undefined });
    }
    var anchor = a && a.getAttribute('href');
    // data-ufp-own-scroll: a lander script moves the page for this link itself (e.g. a tab that slides a swipe row)
    if (anchor && anchor.charAt(0) === '#' && anchor.length > 1 && a.closest('.ufp-lp') && !a.hasAttribute('data-ufp-own-scroll')) {
      var t = doc.getElementById(anchor.slice(1));
      if (t) {
        e.preventDefault();
        if (t.tagName === 'DETAILS') t.open = true;
        scrollToEl(t);
        try { history.replaceState(null, '', anchor); } catch (err) {}
        if (!t.hasAttribute('tabindex') && !/^(A|BUTTON|INPUT|SUMMARY|DETAILS)$/.test(t.tagName)) t.setAttribute('tabindex', '-1');
        try { t.focus({ preventScroll: true }); } catch (err) {}
      }
    }
  }

  /* ------------------------------------------------------------ optional cart attributes (hero setting tag_cart, default off) */
  function tagCart() {
    var h = doc.querySelector('[data-ufp-tag-cart]');
    if (!h || ss('ufp_cart_tagged')) return;
    ss('ufp_cart_tagged', '1');
    try {
      var fd = new FormData();
      fd.append('attributes[lander]', lander(h));
      fd.append('attributes[ufp_ad]', params.utm_content || 'none');
      fd.append('attributes[ufp_campaign]', params.utm_campaign || 'none');
      if (!(navigator.sendBeacon && navigator.sendBeacon('/cart/update.js', fd))) fetch('/cart/update.js', { method: 'POST', body: fd, keepalive: true, credentials: 'same-origin' });
    } catch (e) {}
  }

  /* ------------------------------------------------------------ copy code (tickets, badges, chips) */
  var toastEl, toastT;
  /* The toast sat at bottom 96 px, right over the hero CTA and its price line. It keeps that spot only
     while the sticky pill is showing (it clears the pill); otherwise it sits just above the tapped button (below
     it when there is no room above, under the live header), so it never covers the button the visitor taps next. */
  function placeToast(anchor) {
    var s = toastEl.style;
    s.top = ''; s.bottom = ''; s.left = '';
    toastEl.classList.remove('ufp-lp-toast--at');
    if (doc.querySelector('.ufp-lp-sticky.ufp-lp-is-shown') || !anchor || !anchor.getBoundingClientRect) return;
    var r = anchor.getBoundingClientRect();
    var vh = window.innerHeight || doc.documentElement.clientHeight;
    var vw = window.innerWidth || doc.documentElement.clientWidth;
    if (r.bottom <= 0 || r.top >= vh) return;
    var h = toastEl.offsetHeight || 40, w = toastEl.offsetWidth || 0;
    var minTop = headerOffset() + 8;
    var top = r.top - h - 8;
    if (top < minTop) top = r.bottom + 8;
    top = Math.max(minTop, Math.min(top, vh - h - 8));
    s.top = Math.round(top) + 'px';
    s.bottom = 'auto';
    if (w) s.left = Math.round(Math.max(16, Math.min(r.left, vw - w - 16))) + 'px';
    toastEl.classList.add('ufp-lp-toast--at');
  }
  function toast(msg, anchor) {
    if (!msg) return;
    if (!toastEl) { toastEl = doc.createElement('div'); toastEl.className = 'ufp-lp ufp-lp-toast'; toastEl.setAttribute('aria-hidden', 'true'); doc.body.appendChild(toastEl); }
    toastEl.textContent = msg;
    placeToast(anchor);
    toastEl.classList.add('ufp-lp-is-shown');
    clearTimeout(toastT);
    toastT = setTimeout(function () { toastEl.classList.remove('ufp-lp-is-shown'); }, 3000);
  }
  function legacyCopy(text) {
    try {
      var ta = doc.createElement('textarea');
      ta.value = text; ta.setAttribute('readonly', ''); ta.style.cssText = 'position:fixed;top:0;left:0;opacity:0;font-size:16px';
      doc.body.appendChild(ta); ta.select(); ta.setSelectionRange(0, text.length);
      var ok = doc.execCommand('copy'); doc.body.removeChild(ta); return ok;
    } catch (e) { return false; }
  }
  function copyText(text) {
    try {
      if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(text).then(function () { return true; }, function () { return legacyCopy(text); });
    } catch (e) {}
    return Promise.resolve(legacyCopy(text));
  }
  function bindCopy(root) {
    $$(root, '[data-ufp-copy]').forEach(function (b) {
      if (!once(b, 'copy')) return;
      var label = b.querySelector('[data-ufp-copy-label]');
      var orig = label ? label.textContent : '';
      var wrap = b.parentNode;
      var live = wrap && wrap.querySelector('[data-ufp-copy-live]');
      var t;
      b.addEventListener('click', function () {
        var code = b.getAttribute('data-ufp-copy');
        copyText(code).then(function (ok) {
          clearTimeout(t);
          b.classList.toggle('ufp-lp-is-copied', !!ok);
          if (label) label.textContent = ok ? (b.getAttribute('data-copied') || 'Copied') : (b.getAttribute('data-failed') || 'Hold');
          if (live) live.textContent = ok ? (b.getAttribute('data-live-ok') || '') : (b.getAttribute('data-live-fail') || '');
          if (ok) toast(b.getAttribute('data-ufp-toast'), b);
          else {
            var codeEl = b.querySelector('[data-ufp-copy-code]');
            try { var r = doc.createRange(); r.selectNodeContents(codeEl || b); var s = window.getSelection(); s.removeAllRanges(); s.addRange(r); } catch (e) {}
            toast(b.getAttribute('data-live-fail'), b);
          }
          push({ event: 'ufp_code_copy', ufp_lander: lander(b), ufp_ok: !!ok });
          t = setTimeout(function () { b.classList.remove('ufp-lp-is-copied'); if (label) label.textContent = orig; if (live) live.textContent = ''; }, 3000);
        });
      });
    });
  }

  /* ------------------------------------------------------------ offer end date (Australia/Sydney) and hero authority */
  // YYYY-MM-DD in Sydney, built from parts (never depends on how a locale formats a whole date)
  var ISO_DAY = /^\d{4}-\d{2}-\d{2}$/;
  function sydneyToday() {
    try {
      var p = {};
      new Intl.DateTimeFormat('en-AU', { timeZone: 'Australia/Sydney', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
      var d = p.year + '-' + p.month + '-' + p.day;
      if (ISO_DAY.test(d)) return d;
    } catch (e) {}
    return new Date().toISOString().slice(0, 10);
  }
  // An end date is only trusted as YYYY-MM-DD: a day-first value such as 15-10-2026 would compare as already past
  // and end the offer on day one. Sections print their own offer_end setting unchanged.
  function endPassed(end, today) { return !!end && ISO_DAY.test(end) && today > end; }
  // Offer ended on a cached page: the shared hero prints its offer-off kicker, H1 and subline in
  // <template data-ufp-offer-off>; swap them in (this also replaces an ad-matched offer headline).
  function offHero(hero) {
    var t = hero && hero.querySelector('template[data-ufp-offer-off]');
    if (!t || !t.content) return;
    var c = t.content, h1 = hero.querySelector('h1'), sub = hero.querySelector('.ufp-lp-hero__sub'), kick = hero.querySelector('.ufp-lp-hero__kicker');
    var hh = c.querySelector('[data-h1]'), sb = c.querySelector('[data-sub]'), kk = c.querySelector('[data-kicker]');
    if (h1 && hh) { h1.innerHTML = hh.innerHTML; h1.style.setProperty('--ufp-fit', t.getAttribute('data-fit') || '10.20'); h1.removeAttribute('data-ufp-ad'); }
    if (sub && sb) sub.textContent = sb.textContent;
    if (kick && kk) kick.textContent = kk.textContent;
  }
  function offerGuard() {
    var today = sydneyToday();
    var hero = doc.querySelector('[data-ufp-hero][data-ufp-offer-state]');
    var heroOff = hero && hero.getAttribute('data-ufp-offer-state') === 'off';
    var heroEnd = hero && hero.getAttribute('data-ufp-offer-end');
    if (endPassed(heroEnd, today)) { heroOff = true; offHero(hero); }
    if (heroOff) {
      $$(doc, '.ufp-lp [data-ufp-offer], .ufp-lp[data-ufp-offer]').forEach(function (el) { el.hidden = true; });
      $$(doc, '.ufp-lp [data-ufp-offer-twin]').forEach(function (el) { el.hidden = false; });
      return;
    }
    // cook-style fail-closed markup: offer elements printed hidden, plain twins visible; a hero marked live swaps them
    if (doc.querySelector('[data-ufp-offer-live]')) {
      $$(doc, '[data-ufp-offer-only]').forEach(function (el) { el.hidden = false; });
      $$(doc, '[data-ufp-offer-plain]').forEach(function (el) { el.hidden = true; });
    }
    $$(doc, '[data-ufp-offer-end]').forEach(function (root) {
      var end = root.getAttribute('data-ufp-offer-end');
      if (endPassed(end, today)) {
        if (root.hasAttribute('data-ufp-offer')) root.hidden = true;
        $$(root, '[data-ufp-offer]').forEach(function (el) { el.hidden = true; });
        $$(root, '[data-ufp-offer-twin]').forEach(function (el) { el.hidden = false; });
      }
    });
  }

  /* ------------------------------------------------------------ reveal on scroll (in-view equivalent of hover motion) */
  var revealIO = null;
  function bindReveal(root) {
    var els = $$(root, '.ufp-lp [data-ufp-reveal]');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('ufp-lp-in'); }); return; }
    if (!revealIO) revealIO = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('ufp-lp-in'); revealIO.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    els.forEach(function (el) {
      if (!once(el, 'reveal')) return;
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) { el.classList.add('ufp-lp-in'); return; }
      revealIO.observe(el);
    });
  }

  /* ------------------------------------------------------------ second photo: tap button + in-view on touch (hover is CSS) */
  function bindSwap(root) {
    $$(root, '.ufp-lp [data-ufp-swap]').forEach(function (card) {
      if (!once(card, 'swap')) return;
      var btn = card.querySelector('[data-ufp-swap-toggle]');
      function set(on) { card.classList.toggle('ufp-lp-is-alt', on); if (btn) btn.setAttribute('aria-pressed', on ? 'true' : 'false'); }
      if (btn) btn.addEventListener('click', function (e) { e.preventDefault(); set(!card.classList.contains('ufp-lp-is-alt')); });
      if (fine || reduce || !('IntersectionObserver' in window)) return;
      var timer, io = new IntersectionObserver(function (ents) {
        ents.forEach(function (en) {
          clearTimeout(timer);
          if (en.isIntersecting && en.intersectionRatio >= 0.6) timer = setTimeout(function () { set(true); io.disconnect(); }, 1200);
        });
      }, { threshold: [0, 0.6, 1] });
      io.observe(card);
    });
  }

  /* ------------------------------------------------------------ hero size picker: ufp:size, deep links (?size= / #size-) */
  function sizeDetail(r) {
    return { key: r.getAttribute('data-key'), handle: r.getAttribute('data-handle'), url: r.getAttribute('data-url'), short: r.getAttribute('data-short'), name: r.getAttribute('data-short'), title: r.getAttribute('data-title') || r.getAttribute('data-short'), price: r.getAttribute('data-price'), source: 'size' };
  }
  function bindSizes(root) {
    $$(root, '.ufp-lp [data-ufp-sizes]').forEach(function (fs) {
      if (!once(fs, 'sizes')) return;
      var radios = $$(fs, '[data-ufp-size-radio]');
      if (!radios.length) return;
      var want = null;
      try { var q = new URLSearchParams(location.search).get('size'); if (q) want = q; } catch (e) {}
      var m = location.hash.match(/^#size-([\w-]+)/);
      if (!want && m) want = m[1];
      if (want) radios.forEach(function (r) { if (r.getAttribute('data-key') === want) r.checked = true; });
      fs.addEventListener('change', function (e) {
        var r = e.target;
        if (!r.hasAttribute('data-ufp-size-radio')) return;
        var d = sizeDetail(r);
        emit('ufp:size', d);
        if (fs.getAttribute('data-ufp-hash') === 'size') { try { history.replaceState(null, '', location.pathname + location.search + '#size-' + d.key); } catch (err) {} }
        push({ event: 'ufp_size_select', ufp_size: d.key, ufp_lander: lander(fs) });
      });
      var cur = radios.filter(function (r) { return r.checked; })[0] || radios[0];
      emit('ufp:size', sizeDetail(cur));
    });
  }

  /* ------------------------------------------------------------ option pills on cards (fallback sync where CSS cannot reach) */
  function syncOptions(fs) {
    var card = fs.closest('[data-ufp-card]') || fs.parentNode;
    var checked = fs.querySelector('input[type=radio]:checked');
    if (!checked) return;
    var i = checked.getAttribute('data-i');
    $$(fs, '[data-opt-for]').forEach(function (p) { p.style.display = p.getAttribute('data-opt-for') === i ? 'block' : 'none'; });
    var url = checked.getAttribute('data-url');
    // a note option pointing at a phone number never turns the card photo, name or button into a call; they go
    // to the product page itself (no ?variant, so a 1500 owner is not sent to the 800's lid)
    if (url && card && /^tel:/i.test(url)) url = card.getAttribute('data-base-url');
    if (url && card && !/^tel:/i.test(url)) $$(card, '[data-ufp-card-link]').forEach(function (a) { a.setAttribute('href', withParams(url)); });
    var note = checked.hasAttribute('data-note');
    var add = card && card.querySelector('.ufp-lp-atc__btn');
    if (add) add.hidden = note;
    // the note line is the card's action while a note option is checked (CSS :has() does the same without JS)
    var cta = card && card.querySelector('.ufp-lp-card__cta');
    if (cta) cta.style.display = note ? 'none' : '';
  }
  function bindOptions(root) {
    $$(root, '.ufp-lp [data-ufp-options]').forEach(function (fs) {
      if (!once(fs, 'opts')) return;
      fs.addEventListener('change', function () { syncOptions(fs); });
      syncOptions(fs);
    });
  }
  function onSize(e) {
    var d = e.detail || {};
    $$(doc, '.ufp-lp[data-ufp-size-aware]').forEach(function (grid) {
      $$(grid, '[data-ufp-options]').forEach(function (fs) {
        var hit = fs.querySelector('input[type=radio][data-key="' + String(d.key).replace(/"/g, '') + '"]');
        if (hit && !hit.checked) { hit.checked = true; syncOptions(fs); }
      });
      var help = grid.querySelector('[data-ufp-helper]');
      var map = parseJSON(grid.getAttribute('data-ufp-helpers') || '{}') || {};
      var txt = map[d.key] || map['default'];
      // aria-live region: write only when the text changes (the load-time emit would otherwise be announced)
      if (help && txt) {
        var plain = txt.replace(/\[size\]/g, d.key);
        if (help.textContent.replace(/\s+/g, ' ').trim() !== plain.replace(/\s+/g, ' ').trim()) help.innerHTML = telHtml(plain, 'helper_phone');
      }
    });
    // closing band (ufp-lp-cta-band with follow_size): the picked size's button turns orange
    if (d.handle) $$(doc, '.ufp-lp[data-ufp-follow-size]').forEach(function (band) {
      var btns = $$(band, 'a[data-ufp-band-btn]');
      if (!btns.some(function (a) { return a.getAttribute('data-ufp-product') === d.handle; })) return;
      btns.forEach(function (a) {
        var on = a.getAttribute('data-ufp-product') === d.handle;
        a.classList.toggle('ufp-lp-btn--primary', on);
        a.classList.toggle('ufp-lp-btn--outline-dark', !on);
      });
    });
  }

  /* ------------------------------------------------------------ tabs (budget tabs) and feature size pills: ufp:pick */
  function pickFrom(el, source) { var d = parseJSON(el && el.getAttribute('data-ufp-pick')); if (d) { d.source = source; emit('ufp:pick', d); } }
  function panelLead(panel) {
    if (!panel) return null;
    var fr = panel.querySelector('[data-ufp-fsize-radio]:checked');
    if (fr) { var f = fr.closest('[data-ufp-feature]'); var fp = f && f.querySelector('.ufp-lp-feature__panel[data-i="' + fr.getAttribute('data-i') + '"]'); if (fp) return fp; }
    return panel.querySelector('[data-ufp-pick]');
  }
  function bindTabs(root) {
    $$(root, '.ufp-lp [data-ufp-tabs]').forEach(function (tabs) {
      if (!once(tabs, 'tabs')) return;
      var radios = $$(tabs, '[data-ufp-tab-radio]');
      function panelOf(r) { return tabs.querySelector('.ufp-lp-tabs__panel[data-i="' + r.getAttribute('data-i') + '"]'); }
      function mark() { radios.forEach(function (r) { var p = panelOf(r); if (p) p.classList.toggle('ufp-lp-is-active', r.checked); }); }
      function select(val, scroll) {
        var r = radios.filter(function (x) { return x.value === val || x.getAttribute('data-anchor') === val; })[0];
        if (!r) return false;
        r.checked = true; mark();
        if (scroll) scrollToEl(tabs);
        return true;
      }
      var want = null;
      try { want = new URLSearchParams(location.search).get('budget'); } catch (e) {}
      if (!want && location.hash) want = location.hash.slice(1);
      if (want && !select(want, false)) {
        var alt = doc.getElementById(want) || doc.querySelector('[data-ufp-budget="' + want.replace(/"/g, '') + '"]');
        if (alt && !tabs.contains(alt)) setTimeout(function () { scrollToEl(alt); }, 60);
      } else if (want) setTimeout(function () { scrollToEl(tabs); }, 60);
      mark();
      tabs.addEventListener('change', function (e) {
        var r = e.target;
        if (r.hasAttribute('data-ufp-tab-radio')) {
          mark();
          var anchor = r.getAttribute('data-anchor');
          if (anchor) { try { history.replaceState(null, '', location.pathname + location.search + '#' + anchor); } catch (err) {} }
          emit('ufp:tab', { tab: r.value });
          var lead = panelLead(panelOf(r));
          if (lead) pickFrom(lead, 'tab');
        }
      });
    });
    $$(root, '[data-ufp-tab-link]').forEach(function (a) {
      if (!once(a, 'tablink')) return;
      a.addEventListener('click', function (e) {
        var val = a.getAttribute('data-ufp-tab-link');
        var r = doc.querySelector('[data-ufp-tab-radio][value="' + val.replace(/"/g, '') + '"]');
        if (!r) return;
        e.preventDefault();
        r.checked = true;
        r.dispatchEvent(new Event('change', { bubbles: true }));
        scrollToEl(r.closest('[data-ufp-tabs]'));
      });
    });
    $$(root, '.ufp-lp [data-ufp-feature]').forEach(function (f) {
      if (!once(f, 'feature')) return;
      f.addEventListener('change', function (e) {
        var r = e.target;
        if (!r.hasAttribute('data-ufp-fsize-radio')) return;
        pickFrom(f.querySelector('.ufp-lp-feature__panel[data-i="' + r.getAttribute('data-i') + '"]'), 'size');
      });
    });
  }

  /* ------------------------------------------------------------ FAQ accordion: #deep link opens an item; optional single-open */
  function bindFaq(root) {
    $$(root, '.ufp-lp [data-ufp-faq]').forEach(function (faq) {
      if (!once(faq, 'faq')) return;
      var single = faq.getAttribute('data-ufp-accordion') === 'single';
      $$(faq, 'details').forEach(function (d) {
        d.addEventListener('toggle', function () {
          if (!d.open) return;
          if (single) $$(faq, 'details[open]').forEach(function (o) { if (o !== d) o.open = false; });
          var q = d.querySelector('summary');
          push({ event: 'ufp_faq_open', ufp_lander: lander(d), ufp_faq: q ? q.textContent.trim().slice(0, 80) : '' });
        });
      });
      var t = location.hash ? doc.getElementById(location.hash.slice(1)) : null;
      if (t && t.tagName === 'DETAILS' && faq.contains(t)) { t.open = true; setTimeout(function () { scrollToEl(t); }, 60); }
    });
  }

  /* ------------------------------------------------------------ direct add to cart (theme <product-form> first, own fetch as fallback) */
  function drawerOpen() {
    var d = doc.querySelector('#ajax-cart-drawer');
    return !!((d && d.classList.contains('sidebar-visible')) || doc.body.classList.contains('no-scroll'));
  }
  function bindAtc(root) {
    $$(root, '.ufp-lp form[data-ufp-atc]').forEach(function (form) {
      if (!once(form, 'atc')) return;
      var btn = form.querySelector('[type=submit]');
      var span = btn && btn.querySelector('span');
      var err = form.querySelector('[data-form-error]');
      var done = form.querySelector('[data-ufp-atc-done]');
      var label = span ? span.textContent : '';
      function state(s, msg) {
        if (!btn) return;
        btn.removeAttribute('aria-busy');
        if (s === 'busy') { btn.setAttribute('aria-busy', 'true'); if (span && btn.getAttribute('data-adding')) span.textContent = btn.getAttribute('data-adding'); }
        if (s === 'ok') {
          if (done) done.hidden = false;
          if (span && btn.getAttribute('data-added')) { span.textContent = btn.getAttribute('data-added'); setTimeout(function () { span.textContent = label; }, 2000); } else if (span) span.textContent = label;
          push({ event: 'ufp_add_to_cart', ufp_lander: lander(form), ufp_product: btn.getAttribute('data-ufp-product') });
          tagCart();
        }
        if (s === 'err') {
          if (span) span.textContent = label;
          if (err) { err.textContent = msg || btn.getAttribute('data-error') || ''; err.style.display = 'block'; }
        }
      }
      form.addEventListener('submit', function (e) {
        var idInput = form.querySelector('[name="id"]:checked') || form.querySelector('input[type=hidden][name="id"]');
        if (!idInput || !idInput.value) { e.preventDefault(); state('err'); return; }
        var theme = window.customElements && window.customElements.get('product-form') && form.closest('product-form');
        state('busy');
        if (theme) {
          // The theme posts and opens its drawer. Watch for the drawer or an error for 4 s, then show the cart link anyway.
          var t0 = Date.now();
          (function watch() {
            if (drawerOpen()) return state('ok');
            if (err && err.textContent.trim() && err.style.display !== 'none') return state('err', err.textContent.trim());
            if (Date.now() - t0 > 4000) { if (btn) btn.removeAttribute('aria-busy'); if (done) done.hidden = false; if (span) span.textContent = label; return; }
            setTimeout(watch, 150);
          })();
          return;
        }
        if (!window.fetch || !window.FormData) { btn && btn.removeAttribute('aria-busy'); return; } // native POST to /cart/add
        e.preventDefault();
        fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }, credentials: 'same-origin' })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
          .then(function (res) { if (res.ok && !res.j.status) state('ok'); else state('err', res.j && (res.j.description || res.j.message)); })
          .catch(function () { state('err'); });
      });
    });
  }

  /* ------------------------------------------------------------ carousel (swipe rows; plain scroll snap without JS)
     [data-ufp-carousel] wraps a [data-ufp-carousel-track] scroller whose children carry data-ufp-slide="key" (and
     optionally data-ufp-slide-label). This adds the arrows, the dots and a "2 of 5" status, marks the slide in view
     (.ufp-lp-is-current) and fires ufp:slide {index, key, user, el} on the wrapper each time the row comes to rest:
     user is true for a swipe or an arrow, false when a script asked for the move. Nothing listens for touches: the browser does the
     scrolling, so vertical page scrolling is never taken over. */
  var ICON_PREV = '<svg class="ufp-lp-ico" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m15 5-7 7 7 7"/></svg>';
  var ICON_NEXT = '<svg class="ufp-lp-ico" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m9 5 7 7-7 7"/></svg>';
  function bindCarousel(root) {
    $$(root, '.ufp-lp [data-ufp-carousel]').forEach(function (car) {
      if (!once(car, 'carousel')) return;
      var track = car.querySelector('[data-ufp-carousel-track]');
      if (!track) return;
      var slides = $$(track, '[data-ufp-slide]');
      if (slides.length < 2) return;
      var pattern = car.getAttribute('data-count') || '[n] of [total]';
      var nav = doc.createElement('div');
      nav.className = 'ufp-lp-carousel__nav';
      nav.setAttribute('data-ufp-carousel-nav', '');
      nav.hidden = true;
      var dots = '';
      slides.forEach(function () { dots += '<span class="ufp-lp-carousel__dot"></span>'; });
      var few = slides.length <= 8;
      nav.innerHTML = '<button type="button" class="ufp-lp-carousel__arrow" data-ufp-carousel-prev aria-label="' + esc(car.getAttribute('data-prev') || 'Previous') + '">' + ICON_PREV + '</button>' +
        (few ? '<span class="ufp-lp-carousel__dots" aria-hidden="true">' + dots + '</span>' : '') +
        '<span class="ufp-lp-carousel__count' + (few ? ' ufp-lp-vh' : '') + '" data-ufp-carousel-count aria-live="polite"></span>' +
        '<button type="button" class="ufp-lp-carousel__arrow" data-ufp-carousel-next aria-label="' + esc(car.getAttribute('data-next') || 'Next') + '">' + ICON_NEXT + '</button>';
      car.appendChild(nav);
      var prev = nav.querySelector('[data-ufp-carousel-prev]'), next = nav.querySelector('[data-ufp-carousel-next]');
      var count = nav.querySelector('[data-ufp-carousel-count]'), dotEls = $$(nav, '.ufp-lp-carousel__dot');
      var cur = -1, target = -1, byUser = false, settleT = 0, raf = 0, said = false;

      function scrollable() { return track.scrollWidth > track.clientWidth + 4; }
      function maxLeft() { return Math.max(0, track.scrollWidth - track.clientWidth); }
      function leftFor(i) {
        var tr = track.getBoundingClientRect(), sr = slides[i].getBoundingClientRect();
        var cs = window.getComputedStyle(slides[i]);
        var pad = parseFloat(window.getComputedStyle(track).scrollPaddingLeft) || 0;
        var x = track.scrollLeft + (sr.left - tr.left);
        x -= /start/.test(cs.scrollSnapAlign || '') ? pad : (tr.width - sr.width) / 2;
        return Math.max(0, Math.min(Math.round(x), maxLeft()));
      }
      function nearest() {
        var best = 0, bestD = Infinity, x = track.scrollLeft;
        slides.forEach(function (s, i) { var d = Math.abs(leftFor(i) - x); if (d < bestD - 0.5) { bestD = d; best = i; } });
        return best;
      }
      function paint(i) {
        cur = i;
        slides.forEach(function (s, n) { s.classList.toggle('ufp-lp-is-current', n === i); });
        dotEls.forEach(function (d, n) { d.classList.toggle('ufp-lp-is-on', n === i); });
        nav.hidden = !scrollable();
        prev.disabled = i <= 0;
        next.disabled = i >= slides.length - 1 || track.scrollLeft >= maxLeft() - 2;
        car.setAttribute('data-ufp-carousel-index', String(i));
      }
      function say(i) {
        var label = slides[i].getAttribute('data-ufp-slide-label');
        count.textContent = pattern.replace('[n]', i + 1).replace('[total]', slides.length) + (label && said ? ': ' + label : '');
      }
      function settle() {
        var i = nearest(), user = byUser || target < 0 || target !== i;
        target = -1;
        byUser = false;
        if (i !== cur) { paint(i); said = true; say(i); } else paint(i);
        try { car.dispatchEvent(new CustomEvent('ufp:slide', { bubbles: true, detail: { index: i, key: slides[i].getAttribute('data-ufp-slide'), user: user, el: slides[i] } })); } catch (e) {}
      }
      function onScroll() {
        if (!raf) raf = requestAnimationFrame(function () { raf = 0; if (target < 0) { var i = nearest(); if (i !== cur) { paint(i); said = true; say(i); } } });
        clearTimeout(settleT);
        settleT = setTimeout(settle, 140);
      }
      function go(i, instant, user) {
        if (typeof i === 'string') { var k = i; i = -1; slides.forEach(function (s, n) { if (s.getAttribute('data-ufp-slide') === k) i = n; }); }
        if (i < 0 || i >= slides.length) return false;
        if (!scrollable()) { paint(i); return true; }
        var x = leftFor(i);
        paint(i);
        say(i);
        if (Math.abs(x - track.scrollLeft) < 2) return true;
        target = i;
        byUser = !!user;
        try { track.scrollTo({ left: x, behavior: instant || reduce ? 'auto' : 'smooth' }); } catch (e) { track.scrollLeft = x; }
        clearTimeout(settleT);
        settleT = setTimeout(settle, 900);
        return true;
      }
      car.ufpGo = go;
      car.ufpIndex = function () { return cur; };
      prev.addEventListener('click', function () { said = true; go(Math.max(0, cur - 1), false, true); });
      next.addEventListener('click', function () { said = true; go(Math.min(slides.length - 1, cur + 1), false, true); });
      track.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', function () { paint(nearest()); });
      paint(nearest());
      say(cur);
      car.classList.add('ufp-lp-is-ready');
    });
  }
  // ufpLp.carousel(el) -> { go(indexOrKey, instant), index() } for lander scripts
  U.carousel = function (el) { return el && el.ufpGo ? { go: el.ufpGo, index: el.ufpIndex } : null; };

  /* ------------------------------------------------------------ sticky CTA (phones; bottom left; clear of Podium) */
  function bindSticky(root) {
    $$(root, '[data-ufp-sticky]').forEach(function (bar) {
      if (!once(bar, 'sticky')) return;
      var link = bar.querySelector('[data-ufp-sticky-link]');
      var lab = bar.querySelector('[data-ufp-sticky-label]');
      var nameEl = bar.querySelector('[data-ufp-sticky-name]');
      var priceEl = bar.querySelector('[data-ufp-sticky-price]');
      var pattern = bar.getAttribute('data-pattern') || '[name] · [price]';
      var follow = bar.hasAttribute('data-follow');
      var desktop = bar.hasAttribute('data-desktop');
      var pod = doc.querySelector('[data-ufp-podium]');
      var mode = pod ? pod.getAttribute('data-ufp-podium') : 'popup';
      if (mode === 'off') bar.classList.add('ufp-lp-sticky--wide');
      bar.classList.add('ufp-lp-is-ready');
      var hideSel = bar.getAttribute('data-hide-while') || '[data-ufp-sticky-hide], [data-ufp-cta-zone]';
      var afterSel = bar.getAttribute('data-show-after') || '[data-ufp-hero-cta]';
      var zones = [];
      try { zones = $$(doc, hideSel); } catch (e) { zones = $$(doc, '[data-ufp-sticky-hide], [data-ufp-cta-zone]'); }
      var inZone = new Set();
      function afterEl() {
        var els = [];
        try { els = $$(doc, afterSel); } catch (e) {}
        for (var i = 0; i < els.length; i++) if (els[i].offsetParent !== null) return els[i];
        return els[0] || null;
      }
      function apply(d) {
        if (!follow || !d) return;
        var name = d.short || d.name || '';
        var label = d.sticky_label || pattern.replace('[name]', name).replace('[short]', name).replace('[price]', d.price || '').replace(/\s·\s$/, '');
        if (lab && label) lab.textContent = label;
        // bar style: the picked item on one line, its price on the next; the link's name reads as one sentence
        if (nameEl && (d.title || name)) nameEl.textContent = d.title || name;
        if (priceEl && d.price) priceEl.textContent = d.price;
        if (nameEl && link && label) link.setAttribute('aria-label', label);
        var href = d.url || d.href;
        if (link && href) link.setAttribute('href', withParams(href));
      }
      function update() {
        var wide = window.innerWidth >= 990 && !desktop;
        var a = afterEl();
        var past = a ? a.getBoundingClientRect().bottom < 0 : window.scrollY > window.innerHeight * 0.8;
        var ae = doc.activeElement;
        var typing = ae && /^(INPUT|TEXTAREA|SELECT)$/.test(ae.tagName) && ae.type !== 'radio' && ae.type !== 'checkbox';
        var show = !wide && past && inZone.size === 0 && !typing && !drawerOpen();
        bar.classList.toggle('ufp-lp-is-shown', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        if (link) link.setAttribute('tabindex', show ? '0' : '-1');
      }
      if ('IntersectionObserver' in window && zones.length) {
        var io = new IntersectionObserver(function (ents) {
          ents.forEach(function (en) { if (en.isIntersecting) inZone.add(en.target); else inZone.delete(en.target); });
          update();
        });
        zones.forEach(function (z) { io.observe(z); });
      }
      var raf = 0;
      window.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(function () { raf = 0; update(); }); }, { passive: true });
      window.addEventListener('resize', update);
      doc.addEventListener('focusin', update);
      doc.addEventListener('focusout', function () { setTimeout(update, 50); });
      var drawer = doc.querySelector('#ajax-cart-drawer');
      if (drawer && 'MutationObserver' in window) {
        var mo = new MutationObserver(update);
        mo.observe(drawer, { attributes: true, attributeFilter: ['class', 'style'] });
        mo.observe(doc.body, { attributes: true, attributeFilter: ['class'] });
      }
      ['ufp:size', 'ufp:pick', 'ufp:primary-cta'].forEach(function (n) { doc.addEventListener(n, function (e) { apply(e.detail); }); });
      apply(U.last['ufp:primary-cta'] || U.last['ufp:pick'] || U.last['ufp:size']);
      update();
    });
  }

  /* ------------------------------------------------------------ boot */
  function init(root) {
    root = root || doc;
    $$(root, '.ufp-lp').forEach(function (el) { el.classList.add('ufp-lp-js'); el.setAttribute('data-ufp-js', 'ran'); });
    if (root.classList && root.classList.contains('ufp-lp')) root.classList.add('ufp-lp-js');
    offerGuard();
    passLinks(root);
    bindCopy(root);
    bindReveal(root);
    bindSwap(root);
    bindOptions(root);
    bindTabs(root);
    bindFaq(root);
    bindAtc(root);
    bindCarousel(root);
    bindSizes(root);
    bindSticky(root);
  }
  U.init = init;
  doc.addEventListener('click', onClick, true);
  doc.addEventListener('ufp:size', onSize);
  doc.addEventListener('shopify:section:load', function (e) { init(e.target); });
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', function () { init(doc); });
  else init(doc);
})();
